import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { PitSourceActivityVersion } from "./pit-source-activity-version";
import { PitFinancingRedistributionBySource } from "./pit-financing-redistribution-by-source";
import { DxGridRow } from "../../dx-grid/domain/dx-grid-row";
import { DxCoreUtils } from "../../dx-core/utiles/dx-core-utils";
/** Перераспределение финансирования между мероприятиями */
let PitFinancingRedistribution = class PitFinancingRedistribution extends DxGridRow {
    constructor(fields) {
        super();
        /** Версия мероприятия «донора» */
        this._sourceActivityVersion = new PitSourceActivityVersion();
        /** Видимо версия текущего мероприятия (в карточке) */
        this._destinationActivityVersion = new PitSourceActivityVersion();
        /** Массив строк перераспределения финансирования между мероприятиями по источникам */
        this._financingRedistributionBySource = [];
        this._fakeId = DxCoreUtils.randomHexaDecimal();
        if (fields) {
            Object.assign(this, fields);
        }
    }
    get sourceActivityVersionId() {
        return this.sourceActivityVersion ? this.sourceActivityVersion.id : null;
    }
    get isNew() {
        return this.id !== this._id;
    }
    get id() {
        return this._id ? this._id : this._fakeId;
    }
    set id(value) {
        this._id = value;
    }
    getRowId() {
        return this.id;
    }
    get sourceActivityVersion() {
        return this._sourceActivityVersion;
    }
    set sourceActivityVersion(value) {
        this._sourceActivityVersion = value;
    }
    get destinationActivityVersion() {
        return this._destinationActivityVersion;
    }
    set destinationActivityVersion(value) {
        this._destinationActivityVersion = value;
    }
    get statusId() {
        return this._statusId;
    }
    set statusId(value) {
        this._statusId = value;
    }
    get status2Ids() {
        return this._status2Ids;
    }
    set status2Ids(value) {
        this._status2Ids = value;
    }
    get financingRedistributionBySource() {
        return this._financingRedistributionBySource;
    }
    set financingRedistributionBySource(value) {
        this._financingRedistributionBySource = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingRedistribution.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "sourceActivityVersion", constructor: PitSourceActivityVersion, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", PitSourceActivityVersion)
], PitFinancingRedistribution.prototype, "_sourceActivityVersion", void 0);
tslib_1.__decorate([
    jsonMember({ name: "destinationActivityVersion", constructor: PitSourceActivityVersion, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", PitSourceActivityVersion)
], PitFinancingRedistribution.prototype, "_destinationActivityVersion", void 0);
tslib_1.__decorate([
    jsonArrayMember(PitFinancingRedistributionBySource, { name: "financingRedistributionBySource", emitDefaultValue: false, preserveNull: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitFinancingRedistribution.prototype, "_financingRedistributionBySource", void 0);
tslib_1.__decorate([
    jsonMember({ name: "statusId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingRedistribution.prototype, "_statusId", void 0);
tslib_1.__decorate([
    jsonArrayMember(Number, { name: "status2Ids", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitFinancingRedistribution.prototype, "_status2Ids", void 0);
tslib_1.__decorate([
    jsonMember({ name: "sourceActivityVersionId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number),
    tslib_1.__metadata("design:paramtypes", [])
], PitFinancingRedistribution.prototype, "sourceActivityVersionId", null);
PitFinancingRedistribution = tslib_1.__decorate([
    jsonObject,
    tslib_1.__metadata("design:paramtypes", [Object])
], PitFinancingRedistribution);
export { PitFinancingRedistribution };
